import { render, staticRenderFns } from "./winnertextbox.vue?vue&type=template&id=a1953fe8&scoped=true&"
import script from "./winnertextbox.vue?vue&type=script&lang=js&"
export * from "./winnertextbox.vue?vue&type=script&lang=js&"
import style0 from "./winnertextbox.vue?vue&type=style&index=0&id=a1953fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1953fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/path0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a1953fe8')) {
      api.createRecord('a1953fe8', component.options)
    } else {
      api.reload('a1953fe8', component.options)
    }
    module.hot.accept("./winnertextbox.vue?vue&type=template&id=a1953fe8&scoped=true&", function () {
      api.rerender('a1953fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/winnertextbox.vue"
export default component.exports